@if (loading) {
  <div class="flex justify-center items-center py-20">
    <div
      class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"
    ></div>
  </div>
}
